$shm_paginator $mol_view
	page? 0
	total 0
	page_size 50
	sub /
		<= Numbers $mol_view
			sub <= buttons /
		<= Info $mol_view
			sub / <= info \
	Button* $mol_button_minor
		title <= button_title* \
		attr *
			^
			aria-current <= button_current* null
		click? <=> pick*? null
	Gap* $mol_view
		sub / \…
